import { Monitor } from 'lucide-react'
import styles from './DesktopOnlyBanner.module.scss'

/**
 * Discreet mobile-only notice that the current screen is tuned for
 * desktop. Doesn't block usage — Factory and Tools pages still open and
 * work — but warns that some inputs may be cramped. AppLayout decides
 * when to render this (route + viewport).
 */
export function DesktopOnlyBanner() {
  return (
    <div className={styles.banner} role="status">
      <Monitor aria-hidden className={styles.icon} />
      <span>
        Esta ferramenta funciona melhor no desktop. No mobile alguns campos
        podem ficar apertados.
      </span>
    </div>
  )
}
